import React, { Component } from "react";
import {
  API_TOKEN_NAME,
  USER_ROLE,
  USER_ID,
  USER_EMAIL,
  LOGIN_PHONE_NUMBER,
  PATIENT_NAME,
  SEARCH_SELECTED_DOC_ID,
  SCHEDULE_DATE,
  SCHEDULE_TIME,
  USER_LOCAL_ID,
  PATIENT_DATE_OF_BIRTH,
} from "../../constants";
import { Route } from "react-router-dom";
import { startUserSession } from "../../userSession";
import { scAxiosAdmin, scAxios } from "../..";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Footer from "../../component/frontend/Footer";
import uhlcare_logo from "../../images/uhlcare-logo.webp";
import uhl_logo from "../../images/UHL (2).webp";
import medix_logo from "../../images/medix-logo.webp";
import ma_rashed_logo from "../../images/ma rashed hospital.webp";
import mainlogo from "../../images/main-logo.webp";

import HomeSearch from "../../component/frontend/commonsections/HomeSearch";
import CenterExcellence from "../../component/frontend/commonsections/CenterExcellence";
import NewsEventsSilde from "../../component/frontend/commonsections/NewsEventsSilde";
import PublicationsSilde from "../../component/frontend/commonsections/PublicationsSilde";
import Moment from "moment";
import HeaderHome from "../frontend/HeaderHome";
import { withRouter } from "react-router-dom";

const bookingAppoinments = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxios.request("/AppointmentBooking", {
      method: "post",
      headers: {
        Accept: "application/json",
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const sendSMS = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/sendcustomsms", {
      method: "post",
      headers: {
        Accept: "application/json",
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getPatientIdByPayment = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxios.request("/mmpatientRegistration", {
      method: "get",
      headers: {
        Accept: "application/json",
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const RegisterData = async (data, id) => {
  return new Promise((resolve, reject) => {
    //const token = Buffer.from(`${API_AUTH_USERNAME}:${API_AUTH_PASSWORD}`, 'utf8').toString('base64');
    const req = scAxiosAdmin.request(`/user/update_patient/${id}`, {
      method: "put",
      data,
      headers: {
        Accept: "application/json",
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

const UpdateAppoinmentData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/payment/updateappointemntdetails", {
      method: "post",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
class Success extends Component {
  state = {
    transaction_id: "",
    appointment_id: "",
    appointment_date: "",
    appointment_time: "",
    patient_name: "",
    doctor_name: "",
    doctor_fees: "",
    total_amount: "",
    payment_status: "",
    currency: "",
    paymentMode: "",
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  refreshUpdateAppoinmentData = (data) => {
    UpdateAppoinmentData(data)
      .then((res) => {
        if (res) {
          let token = localStorage.getItem(API_TOKEN_NAME);
          let phone_number = localStorage.getItem(LOGIN_PHONE_NUMBER);
          let search_selected_doc_id = "";
          let patientid = localStorage.getItem(USER_ID);
          let user_email = localStorage.getItem(USER_EMAIL);
          let user_role = localStorage.getItem(USER_ROLE);

          let localId = localStorage.getItem(USER_LOCAL_ID);
          let date_of_birth = localStorage.getItem(PATIENT_DATE_OF_BIRTH);

          let schedule_date = "";
          //let apointment_id = res[0].AppointmentID;
          let apointment_id = "";
          let doctor_name = "";
          let doctor_fees = "";
          let patientName = localStorage.getItem(PATIENT_NAME);
          let schedule_time = "";
          let search_selected_doc_name = "";
          let doctor_profile_avability = "";
          startUserSession(
            token,
            user_role,
            user_email,
            patientid,
            phone_number,
            search_selected_doc_id,
            schedule_date,
            apointment_id,
            doctor_name,
            doctor_fees,
            patientName,
            schedule_time,
            search_selected_doc_name,
            doctor_profile_avability,
            localId,
            date_of_birth
          );

          var records = res.data;
          this.setState({
            transaction_id: records.transaction_id,
            appointment_id: records.appointment_id,
            appointment_date: records.appointment_date,
            appointment_time: records.appointment_time,
            patient_name: records.patient_name,
            doctor_name: records.doctor_name,
            doctor_fees: records.doctor_fees,
            total_amount: records.amount,
            payment_status: records.status,
            currency: records.currency,
          });
          //this.setState({ patientLists: records });
        } else {
          //this.setState({ patientLists: '' });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    var trans_id = query.get("trans_id");
    /* if(trans_id){
      const data = {
        PatientID: localStorage.getItem(USER_ID),
        DoctorID: localStorage.getItem(SEARCH_SELECTED_DOC_ID),
        Scheduledate: localStorage.getItem(SCHEDULE_DATE),
        Scheduletime: localStorage.getItem(SCHEDULE_TIME),
      }
      
      bookingAppoinments(data)
      .then(res => {
        console.log("test con",res);
        const data = {
          transaction_id: trans_id,
          appointment_id: res[0].AppointmentID,
          appointment_date: localStorage.getItem(SCHEDULE_DATE),
          appointment_time: localStorage.getItem(SCHEDULE_TIME),
        }
        this.refreshUpdateAppoinmentData(data);
      })
      .catch(err => {
        toast.error('Appointment not booked successful!', {
          position: toast.POSITION.TOP_LEFT
           });
      });
    } */
    const inputDate = localStorage.getItem(SCHEDULE_DATE);
    // Convert input date to Date object
    const dateObj = new Date(inputDate);

    // Extract year, month, and day from the Date object
    const year = dateObj.getFullYear();
    const month = `0${dateObj.getMonth() + 1}`.slice(-2); // Adding 1 as month starts from 0
    const day = `0${dateObj.getDate()}`.slice(-2);

    // Form the desired date string
    const formattedDate = `${year}-${month}-${day}`;
    const data = {
      PatientID: localStorage.getItem(USER_ID),
      DoctorID: localStorage.getItem(SEARCH_SELECTED_DOC_ID),
      Scheduledate: formattedDate,
      Scheduletime: localStorage.getItem(SCHEDULE_TIME),
    };
    const sms_data = {
      phone_number: localStorage.getItem(LOGIN_PHONE_NUMBER),
      message: "Your requested has been received. We'll call you soon.",
    };
    const queryParams = new URLSearchParams(this.props.location.search);

    const paymentMode = queryParams.get("Paymentmode");
    this.setState({ paymentMode: paymentMode });

    if (
      data.Scheduledate &&
      data.Scheduletime &&
      paymentMode !== "booking_request"
    ) {
      bookingAppoinments(data)
        .then((res) => {
          const data = {
            transaction_id: trans_id,
            appointment_id: res[0].AppointmentID,
            appointment_date: formattedDate,
            appointment_time: localStorage.getItem(SCHEDULE_TIME),
          };
          this.refreshUpdateAppoinmentData(data);
        })
        .catch((err) => {
          toast.error("Appointment not booked successful!", {
            position: toast.POSITION.TOP_LEFT,
          });
        });
    }
    if (paymentMode === "booking_request") {
      sendSMS(sms_data)
        .then((res) => {
          // this.refreshUpdateAppoinmentData(data);
        })
        .catch((err) => {
          toast.error("Appointment not booked successful!", {
            position: toast.POSITION.TOP_LEFT,
          });
        });
    }
    if (paymentMode === "patient_registration") {
      const id = localStorage.getItem(USER_LOCAL_ID);
      const Cardno = queryParams.get("Cardno") || "null";
      const Cardtype = queryParams.get("Cardtype")
        ? queryParams.get("Cardtype")
        : "null";
      const xtrnno = queryParams.get("xtrnno");
      const Cardamt = queryParams.get("Cardamt");
      const Name = localStorage.getItem(PATIENT_NAME);
      const DateOfBirth = localStorage.getItem(PATIENT_DATE_OF_BIRTH);
      const PhoneNumber = localStorage.getItem(LOGIN_PHONE_NUMBER);
      const Address = "Bangladesh";
      const data = {
        Cardno,
        Cardtype,
        xtrnno,
        Cardamt,
        Name,
        Address,
        DateOfBirth,
        PhoneNumber,
      };
      getPatientIdByPayment(data)
        .then((res) => {
          // this.refreshUpdateAppoinmentData(data);
          const patient_id = `${res.PatientID}`;
          
          const isapproved = "1";
          const user = {
            patient_id,
            isapproved,
          };
          RegisterData(user, id)
            .then((res) => {
              // this.refreshResetOTPData();
              
              localStorage.setItem(USER_ID, res.data.patient_id);
              toast.success("User Registered Successfully!", {
                position: toast.POSITION.TOP_LEFT,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          toast.error("Something went wrong! Please try again", {
            position: toast.POSITION.TOP_LEFT,
          });
        });
    }
  }
  render() {
    return (
      <div>
        <section className="banner-part">
          <Route component={HeaderHome} />
          <div className="container">
            <div
              className="offcanvas offcanvas-start show"
              tabIndex={-1}
              id="offcanvasExample"
              aria-labelledby="offcanvasExampleLabel"
            >
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                  {" "}
                </h5>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                />
              </div>
              <div className="offcanvas-body">
                <div className="row text-center" id="logos">
                  <div className="col-2 ">
                    <img src={uhlcare_logo} alt="uhlcare-logo" />
                  </div>
                  <div className="col-2">
                    <img src={mainlogo} alt="medix-logo" />
                  </div>
                  <div className="col-2">
                    <img src={uhl_logo} alt="uhl-logo" />
                  </div>
                  <div className="col-2">
                    <img src={medix_logo} alt="medix-logo" />
                  </div>

                  <div className="col-2">
                    <img src={ma_rashed_logo} alt="medix-logo" />
                  </div>
                </div>
                <div className="left-offcanvas">
                  <p style={{ "text-align": "center" }}>
                    <i
                      className="fa fa-check-circle mt-10"
                      aria-hidden="true"
                      style={{ color: "#39e75f", "font-size": "80px" }}
                    ></i>
                  </p>
                  {console.log(
                    "this.state.paymentMode",
                    this.state.paymentMode
                  )}
                  <h4
                    className="mt-3"
                    style={{
                      color: "#39e75f",
                      "text-align": "center",
                      fontSize: "22px",
                    }}
                  >
                    {this.state.paymentMode === "patient_registration"
                      ? "Registration Successful!"
                      : "Booking Successful!"}
                  </h4>
                  {this.state.paymentMode === "booking_request" ? (
                    <div className="payment mt-5">
                      <p>
                        Hi, <strong>{this.state.patient_name}</strong>
                      </p>
                      <p>
                        Your Appointment was booked successfully!! Please arrive
                        in the hospital 30 minutes before schedule.
                      </p>
                      {/*<h3 style={{"font-size":"20px", "font-weight":"600"}}>Payment details:</h3>
                          <ul>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Transaction ID: </strong> {this.state.transaction_id}</li>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment ID:</strong> {this.state.appointment_id}</li>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Date:</strong> {Moment(this.state.appointment_date).format('dddd, LL')}</li>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Time:</strong> {Moment(this.state.appointment_time, "HH:mm").format("hh:mm A")}</li>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Doctor Name: </strong> {this.state.doctor_name}</li>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Doctor Fees: </strong> {this.state.currency} {this.state.doctor_fees}</li>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Total Amount: </strong> {this.state.currency} {this.state.total_amount}</li>
                              <li style={{"list-style": "none", "line-height": "40px"}}><strong>Payment Status: </strong>{this.state.payment_status} </li>
                          </ul>*/}
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <div className="payment mt-5">
                    <p>
                      Hi, <strong>{this.state.patient_name}</strong>
                    </p>
                    <p>
                      Your Appointment was booked successfully!! Please arrive
                      in the hospital 30 minutes before schedule.
                    </p>
                    <h3 style={{"font-size":"20px", "font-weight":"600"}}>Payment details:</h3>
                        <ul>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Transaction ID: </strong> {this.state.transaction_id}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment ID:</strong> {this.state.appointment_id}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Date:</strong> {Moment(this.state.appointment_date).format('dddd, LL')}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Time:</strong> {Moment(this.state.appointment_time, "HH:mm").format("hh:mm A")}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Doctor Name: </strong> {this.state.doctor_name}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Doctor Fees: </strong> {this.state.currency} {this.state.doctor_fees}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Appointment Total Amount: </strong> {this.state.currency} {this.state.total_amount}</li>
                            <li style={{"list-style": "none", "line-height": "40px"}}><strong>Payment Status: </strong>{this.state.payment_status} </li>
                        </ul>
                  </div> */}
                </div>
              </div>
            </div>
            <HomeSearch />
          </div>
        </section>
        <CenterExcellence />
        <NewsEventsSilde />
        <PublicationsSilde />
        <Route component={Footer} />
      </div>
    );
  }
}

export default withRouter(Success);



// WEBPACK FOOTER //
// ./src/component/payment/success.js